"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logGraphErrorsArray = exports.productCardVariants = exports.articleQuery = exports.productQuery = exports.collectionQuery = exports.collectionProductsQuery = exports.placeholderImage = exports.maxRelatedBooksOnload = exports.storefrontAccessToken = exports.graphQlUrl = void 0;

require("core-js/modules/es6.array.for-each");

var _themeCurrency = require("@shopify/theme-currency");
/**
 * Template: Article
 * ------------------------------------------------------------------------------
 * Article page strings & queries.
 *
 * @namespace ArticleUtils
 */


var graphQlUrl = '/api/2019-07/graphql.json';
exports.graphQlUrl = graphQlUrl;
var storefrontAccessToken = '2a217033303b1eb7d3e30ba786c79c59';
exports.storefrontAccessToken = storefrontAccessToken;
var maxRelatedBooksOnload = 12;
exports.maxRelatedBooksOnload = maxRelatedBooksOnload;
var placeholderImage = 'https://cdn.shopify.com/s/files/1/0040/4681/5305/files/cover_placeholder.jpg?v=1579710102';
exports.placeholderImage = placeholderImage;

var collectionProductsQuery = function collectionProductsQuery(query, pagination) {
  var cursor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return "\n{ collectionByHandle(handle:\"".concat(query, "\") {\n    id\n    title\n    handle\n    products (first: ").concat(pagination, ", after:").concat(cursor, ") {\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n      }\n      edges { \n        cursor\n        node { \n          id\n          title\n          handle\n          tags\n          collections(first: 5) {\n            edges {\n              node {\n                handle\n              }\n            }\n          }\n          productType\n          onlineStoreUrl\n          images(first:1) {\n            edges {\n              node {\n                originalSrc\n              }\n            }\n          }\n          variants(first:2) {\n            edges {\n              node {\n                sku\n                title\n                price\n                compareAtPrice\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}");
};

exports.collectionProductsQuery = collectionProductsQuery;

var collectionQuery = function collectionQuery(query) {
  return "\n  { \n    collections(first:5, query:\"".concat(query, "\") {\n      edges {\n        node {\n          title\n          handle\n        }\n      }\n    }\n  }\n");
};

exports.collectionQuery = collectionQuery;

var productQuery = function productQuery(query, pagination) {
  var cursor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return "\n{ products (\n  first:".concat(pagination, ",\n  query:\"").concat(query, " AND -subscription\",\n  after:").concat(cursor, "\n  ) { \n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n    }\n    edges { \n      cursor\n      node { \n        id\n        title\n        handle\n        tags\n        collections(first: 5) {\n          edges {\n            node {\n              handle\n            }\n          }\n        }\n        productType\n        onlineStoreUrl\n        images(first:1) {\n          edges {\n            node {\n              originalSrc\n            }\n          }\n        }\n        variants(first:2) {\n          edges {\n            node {\n              sku\n              title\n              price\n              compareAtPrice\n            }\n          }\n        }\n      }\n    }\n  }\n}");
};

exports.productQuery = productQuery;

var articleQuery = function articleQuery(query, pagination) {
  var cursor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return "\n{ articles (\n  first:".concat(pagination, ",\n  query:\"").concat(query, "*\",\n  after:").concat(cursor, "\n  ) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n    }\n    edges { \n      cursor\n      node { \n        id\n        title\n        tags\n      }\n    }\n  }\n}");
};

exports.articleQuery = articleQuery;

var productCardVariants = function productCardVariants(variantTitle, price, compareAtPrice) {
  var hasCompareAtPrice = compareAtPrice !== null;
  return "\n  <div class=\"card__variant\">\n    <div class=\"card__variant-title\">\n      ".concat(variantTitle, "\n    </div>\n    <div class=\"card__variant-price\">\n      ").concat((0, _themeCurrency.formatMoney)(price, theme.moneyFormat), " <s>").concat(hasCompareAtPrice ? (0, _themeCurrency.formatMoney)(compareAtPrice, theme.moneyFormat) : '', "</s>\n    </div>\n  </div>");
};

exports.productCardVariants = productCardVariants;

var logGraphErrorsArray = function logGraphErrorsArray(errors) {
  errors.forEach(function (error) {
    return window.console.error('GraphQl Error: ', error);
  });
};

exports.logGraphErrorsArray = logGraphErrorsArray;